import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { fillEmptyRowData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';

const DEFAULT_WIDTH = 480;
const DEFAULT_HEIGHT = 300;

const DEFAULT_HISTOGRAM_CHART_DATA = {
  generalOptions: {
    binSize: 10,
    borderColor: '#FFF',
    borderWidth: 1,
    innerSize: 0,
  },
  legend: {
    enabled: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  xAxis: {
    title: {
      text: 'Scores',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    title: {
      text: 'Number of testers',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    enableLine: false,
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
  seriesData: fillEmptyRowData([
    { name: 'Data', data: [62, 50, 70, 75, 62, 70, 89, 62, 50, 89, 62, 70, 70, 95] },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
};

export { DEFAULT_HEIGHT, DEFAULT_WIDTH, DEFAULT_HISTOGRAM_CHART_DATA };
